import React, { useEffect, useState } from "react";

import logo from "../../Assets/Logos/logowhite.png";
import "./Header.scss";

export default function Header() {
  const handleLinkClick = (area) => {
    window.location.replace(area);
  };
  return (
    <div className="header d-flex flex-row justify-content-between">
      <div className="d-flex align-items-center logo-section">
        <div className="logo-container">
          <img src={logo} alt="logo" id="header-logo" className=" p-sm-3" />
        </div>
        <div className={`header-text`}>
          <h2 className="text-start text-white fw-bold">SIDE-EYE</h2>
          <h3 className="text-start text-white fw-light">
            VFX and Animation Studio
          </h3>
        </div>
      </div>
      <div className={`nav-links d-flex justify-content-between`}>
        <div className="me-4">
          <a
            className="text-white header-button"
            role="button"
            onClick={() => handleLinkClick("#Landing")}
          >
            Home
          </a>
          <a
            onClick={() => handleLinkClick("#Work")}
            role="button"
            className="text-white mx-5 header-button"
          >
            Work
          </a>
          <a
            onClick={() => handleLinkClick("#About")}
            role="button"
            className="text-white header-button"
          >
            About
          </a>
        </div>
      </div>
    </div>
  );
}
